<template>
    <div class="my-order" ref="container">
        <div class="header bg-color-red" style="height: 1rem">
            <div class="picTxt acea-row row-between-wrapper" style="height: 1rem;display: block;">
                <div style="text-align: center">
                    <p style="line-height: 1rem;font-size: 0.4rem;font-weight:600;color: #fff" >领取劵</p>
                </div>
            </div>
        </div>
        <div style="height: 0.2rem;"></div>

        <div class="list">
            <div class="item" v-for="order in orderList" :key="order.id">
                <div class="title acea-row row-between-wrapper">
                    <div class="acea-row row-middle">
                        <span class="sign cart-color acea-row row-center-wrapper" v-if="order.combination_id > 0">拼团</span>
                        <span class="sign cart-color acea-row row-center-wrapper" v-if="order.seckill_id > 0">秒杀</span>
                        <span class="sign cart-color acea-row row-center-wrapper" v-if="order.bargain_id > 0">砍价</span>
                        {{ order.title }}
                    </div>
                    <div class="font-color-red" v-if="order.lingqu == 0">未领取</div>
                    <div class="font-color-red" v-if="order.lingqu == 1">已领取</div>
                </div>

                <div>
                    <div class="item-info acea-row row-between row-top">
                        <div class="pictrue">
                            <img :src="order.img"/>
                        </div>

                        <div class="text acea-row row-between">
                            <div class="name line2" style="width: auto">
                                {{ order.store_name }} {{ order.store_info }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="totalPrice">
                    到期时间：{{ order.coupons_time2 }}
                </div>

                <div class="bottom acea-row row-right row-middle" style="height: auto">

                    <div style="width: 100%;text-align: center">
                        <div class="font-color-red">{{ order.username }}送你一张优券</div>
                    </div>

                    <div style="height: 1.5rem"></div>
                    <div style="width: 100%;text-align: center;height: 1rem"  @click="lingqu1" v-if="order.lingqu == 0">
                        <span style="background: #f44242;border-radius: 1rem;color: #fff;padding: 0.2rem 1.5rem">立即领取</span>
                    </div>

                    <div style="width: 100%;text-align: center;height: 1rem"  v-if="order.lingqu == 1">
                        <span style="background: #808080;border-radius: 1rem;color: #fff;padding: 0.2rem 1.5rem;">已领取</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { lingqu } from "@api/coupons";
    import {
        cancelOrderHandle,
        takeOrderHandle
    } from "@libs/order";
    import Loading from "@components/Loading";
    import Payment from "@components/Payment";
    import { mapGetters } from "vuex";
    import { isWeixin } from "@utils";
    const NAME = "CardbagLingqu";

    export default {
        name: NAME,
        data() {
            return {
                offlinePayStatus: 2,
                countData: {}, //统计信息
                type: parseInt(this.$route.params.type) || 0,
                page: 1,
                limit: 20,
                loaded: false,
                loading: false,
                orderList: [],
                id: this.$route.params.id|| 0,
            };
        },
        components: {//组件注册
            Loading,
            Payment
        },
        computed: mapGetters(["userInfo"]),
        watch: {//检测路由改变
            $route(n) {
                console.log(n.name);
                if (n.name === NAME) {
                    const id = this.$route.params.id || 0;
                    if (this.type !== type) {
                        this.changeorder(id);
                    }
                }
            }
        },

        methods: {//函数定义
            /**
             * 获取卡卷统计信息
             */
            getCountData(){
                getCardbagCount().then(res => {
                    this.countData = res.data;
                });
            },


            /**
             * 获取信息
             */
            lingqu(){
                lingqu({uniqueID : this.id,type:0}).then(res => {
                    console.log(res.data);
                    this.orderList = this.orderList.concat(res.data);
                }).catch(e=>{
                    this.$dialog.error(e.msg);
                });
            },

            lingqu1(){
                this.$dialog.loading.open("领取中");
                lingqu({uniqueID : this.id,type:1}).then(res => {
                    this.$dialog.loading.close();
                    this.$dialog.success(res.msg);
                    this.$router.push('/user/cardbag');
                    this.$route
                }).catch(e=>{
                    this.$dialog.loading.close();
                    this.$dialog.error(e.msg);
                });
            },

            takeOrder(order) {
                takeOrderHandle(order.order_id).finally(() => {
                    this.reload();
                    this.getDuihuanLesr();
                });
            },

            reload() {
                this.changeType(this.type);
            },

            changeorder(id) {
                console.log(id);
                this.id = id;
                this.orderList = [];
                this.page = 1;
                this.loaded = false;
                this.loading = false;
                this.lingqu();
            },

            //获取状态文字
            getStatus(order) {
                return STATUS[order._status._type];
            },

            cancelOrder(order) {
                cancelOrderHandle(order.order_id)
                    .then(() => {
                        this.orderList.splice(this.orderList.indexOf(order), 1);
                    })
                    .catch(() => {
                        this.reload();
                    });
            },

        },
        mounted() { //初始化方法
            console.log(this.order_id);
            this.lingqu(); //获取统计信息
        }
    };
</script>

<style scoped>

</style>